import React from 'react';
import { Label } from 'src/components/Input';
import { OnStatusClick, Status } from './interfaces';
import { StatusButtonMenu } from './StatusSelect.styles';
import { t } from 'i18next';
import { FormControlLabel, Radio } from '@material-ui/core';
import { onHandleKeyDown } from 'src/utils/onHandleKeyDown';
import { defaultTheme } from 'src/styles';

interface StatusSelectProps {
  status: Status;
  onClick: (status: Status) => void;
}

export const StatusSelect = ({ onClick, status }: StatusSelectProps) => {
  const ArchiveStatus = 'ArchiveStatus';
  const All = 'All';
  const Signed = 'Signed';
  const NotSigned = 'NotSigned';

  const onStatusClick: OnStatusClick = e => onClick(e.currentTarget.value);

  const onRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onClick((event.target as HTMLInputElement).value as Status);
  };

  return (
    <div data-testid="data-testid">
      <Label as="span">{t('Status')}</Label>
      <StatusButtonMenu role="menu">
        <FormControlLabel
          value={All}
          checked={status === All}
          control={
            <Radio
              onChange={onRadioChange}
              color={'primary'}
              onKeyDown={event => onHandleKeyDown(event, onStatusClick)}
              inputProps={{ role: 'radio' }}
              style={{ color: defaultTheme.pallete.buttons.primary }}
            />
          }
          label={t(ArchiveStatus + All)}
        />
        <FormControlLabel
          value={Signed}
          checked={status === Signed}
          control={
            <Radio
              onChange={onRadioChange}
              color={'primary'}
              onKeyDown={event => onHandleKeyDown(event, onStatusClick)}
              inputProps={{ role: 'radio' }}
              style={{ color: defaultTheme.pallete.buttons.primary }}
            />
          }
          label={t(ArchiveStatus + Signed)}
        />
        <FormControlLabel
          value={NotSigned}
          checked={status === NotSigned}
          control={
            <Radio
              onChange={onRadioChange}
              color={'primary'}
              onKeyDown={event => onHandleKeyDown(event, onStatusClick)}
              inputProps={{ role: 'radio' }}
              style={{ color: defaultTheme.pallete.buttons.primary }}
            />
          }
          label={t(ArchiveStatus + NotSigned)}
        />
      </StatusButtonMenu>
    </div>
  );
};
